import { render, staticRenderFns } from "./Surgery.vue?vue&type=template&id=3b8b93ee&scoped=true"
import script from "./Surgery.vue?vue&type=script&lang=js"
export * from "./Surgery.vue?vue&type=script&lang=js"
import style0 from "./Surgery.vue?vue&type=style&index=0&id=3b8b93ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b93ee",
  null
  
)

export default component.exports